import Reveal from "@/components/base/Reveal";
import { ranking, topicBars } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line text-primary-600",
  down: "ri-arrow-down-line text-secondary-600",
  flat: "ri-subtract-line text-foreground-400",
};

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          index="伍"
          title="深扒热度榜"
          desc="按近 7 天的阅读与回访量排序，只做参考，不做背书。"
          actionLabel="查看历史榜单"
          actionHref="#subscribe"
        />

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <Reveal className="lg:col-span-8">
            <ol>
              {ranking.map((item, i) => (
                <li
                  key={item.rank}
                  className={`border-background-300 ${i === 0 ? "border-t" : "border-t"} last:border-b`}
                >
                  <a
                    href="#archive"
                    className="group flex cursor-pointer items-center gap-4 py-4 md:gap-6 md:py-5"
                  >
                    <span
                      className={`w-8 shrink-0 font-heading text-xl font-black md:text-2xl ${
                        i < 2 ? "text-primary-500" : "text-foreground-300"
                      }`}
                    >
                      {item.rank}
                    </span>
                    <h3 className="min-w-0 flex-1 font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
                      {item.title}
                    </h3>
                    <span className="hidden shrink-0 items-center gap-1 text-xs text-foreground-500 sm:flex">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-fire-line text-sm" />
                      </span>
                      {item.heat}
                    </span>
                    <span className="flex h-5 w-5 shrink-0 items-center justify-center">
                      <i className={`${trendIcon[item.trend]} text-base`} />
                    </span>
                  </a>
                </li>
              ))}
            </ol>
          </Reveal>

          <Reveal delay={140} className="lg:col-span-4">
            <div className="h-full rounded-lg border border-background-300 bg-background-50 p-5 md:p-6">
              <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                本期题目分布
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                读者停留最久的四类线索，占比按阅读时长折算。
              </p>

              <div className="mt-6 space-y-4">
                {topicBars.map((bar, i) => (
                  <div key={bar.label}>
                    <div className="flex items-center justify-between text-xs text-foreground-700">
                      <span>{bar.label}</span>
                      <span className="font-medium text-foreground-900">{bar.value}%</span>
                    </div>
                    <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                      <div
                        className={`h-full rounded-full ${i === 0 ? "bg-accent-500" : "bg-secondary-500"}`}
                        style={{ width: `${bar.value}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-6 rounded-md bg-secondary-50 p-4">
                <p className="text-xs leading-relaxed text-secondary-900">
                  榜单每期更新一次。如果你手里有更早的记录，欢迎在订阅后回信补充。
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}